import React, {useContext, useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import Menu from "../Menu";
import {NavLink} from "react-router-dom";
import GenerateURL from "../../utils/generateURL";
import {INDEX_ROUTE} from "../../utils/consts";

import logo from "../../img/logo.svg";
import back_to_top from "../../img/back_to_top.png";
import {useWindowSize} from "../../hooks/useWindowSize";
import {observer} from "mobx-react-lite";
import {MobileMenuContext} from "../../App";
import {ScrollToPositionFixed} from "../../utils/ScrollToPositionFixed";
import device from "current-device";

const Footer = () => {
    const {t} = useTranslation();
    const size = useWindowSize();
    const [bottom, setBottom] = useState(32);
    const [display, setDisplay] = useState('none');
    const [mobileMenu, setMobileMenu] = useContext(MobileMenuContext);

    const backToTop = () => {
        if (window.pageYOffset > 0) {
            window.scrollBy(0, -80);
            setTimeout(backToTop, 0);
        }
    };

    useEffect(() => {
        const BackToTopDisplay = () => {
            if (document.querySelector('.footer')) {
                setBottom((window.scrollY + window.innerHeight) > (document.body.offsetHeight - document.querySelector('.footer').offsetHeight)
                    ? device.mobile() || device.tablet() || document.body.clientWidth <= 1550
                        ? ((window.scrollY + window.innerHeight) - (document.body.offsetHeight - document.querySelector('.footer').offsetHeight)) + 32
                        : ((window.scrollY + window.innerHeight) - (document.body.offsetHeight - document.querySelector('.footer').offsetHeight))
                    : 32);
            }
            if (document.body.clientWidth > 1550) {
                setDisplay(((window.innerHeight * 2) > window.scrollY + window.innerHeight) || (window.scrollY + window.innerHeight > document.body.offsetHeight - document.querySelector('.footer').offsetHeight) ? 'none' : 'flex')
            } else {
                setDisplay(((window.innerHeight * 2) > window.scrollY + window.innerHeight) ? 'none' : 'flex')
            }
        };
        document.addEventListener('scroll', BackToTopDisplay);

        return () => {
            document.removeEventListener('scroll', BackToTopDisplay);
        }
}, [size]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <footer className="footer">
                <div className="row">
                    <div className="left_block">
                        <NavLink className='logo' to={GenerateURL(INDEX_ROUTE)}>
                            <img src={logo} alt="logo"/>
                        </NavLink>
                        {!device.desktop() ? <div className="bottom">
                            <span>{`${new Date().getFullYear()} © ChampionTM`}</span>
                        </div> : null}
                    </div>
                    {device.desktop() ? <Menu separator={false} /> : null}
                    <div className="right_block">
                        {document.body.clientWidth > 1550 ? <div
                            className="back_to_top"
                            onClick={backToTop}
                        >
                            <span>{t('Вгору')}</span>
                            <img src={back_to_top} alt={t('Вгору')}/>
                        </div> : null}
                        <div className="right_block_content">
                            {!device.desktop() ? <button
                                type="button"
                                className={`mobile_click ${mobileMenu ? 'open' : 'close'}`}
                                onClick={() => {
                                    if (mobileMenu) {
                                        ScrollToPositionFixed(true);
                                        setMobileMenu(false);
                                    } else {
                                        setMobileMenu(!mobileMenu);
                                        ScrollToPositionFixed(false, window.pageYOffset);
                                    }
                                }} /> : null}
                        </div>
                    </div>
                    {device.desktop() ? <div className="bottom">
                        <span>{`${new Date().getFullYear()} © ChampionTM`}</span>
                    </div> : null}
                </div>
            </footer>
            <div
                className="back_to_top cube"
                onClick={backToTop}
                style={{
                    display: display,
                    bottom: `${document.body.clientWidth <= 1550 && bottom}px`
                }}
            >
                <span>{t('Вгору')}</span>
                <img src={back_to_top} alt={t('Вгору')}/>
            </div>
        </>
    );
};

export default observer(Footer);